// src/components/layouts/wrappers/SectionContent/SectionContent.tsx
import styled from "styled-components";

export const SectionContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xl};
  width: 100%;
  z-index: 2;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.lg};
  }
`;